<template>
  <div class="p-terms-and-conditions c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheSimpleHeader />

      <div class="p-terms-and-conditions__inner c-common-inner">
        <CommonHeading class="p-terms-and-conditions__heading">
          Terms &amp; Conditions
        </CommonHeading>

        <div class="p-terms-and-conditions__file">
          <embed :src="terms" />
        </div>
      </div>
    </div>

    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import TheSimpleHeader from "@/common/components/organisms/TheSimpleHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import LocalStorage from "@/general/utils/storage";

@Options({
  components: {
    TheSimpleHeader,
    TheFooter,
    CommonHeading
  }
})
export default class TermsAndConditions extends Vue {
  terms = "";

  created() {
    // const allOrgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [{}];
    // const orgAdminSettings = allOrgAdminSettings[0];

    // this.terms = orgAdminSettings.membership_term_url;

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      this.terms = userDetailsJson.membership_term_url;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-terms-and-conditions {
  background-color: $common-white;
  &__inner {
    padding-bottom: rem(80);
    @include sp {
      padding-bottom: rem(40);
    }
  }
  &__heading {
    margin-top: rem(48);
    margin-bottom: rem(16);
    justify-content: center;
    @include sp {
      margin-top: rem(24);
    }
  }
  &__file embed {
    width: 100%;
    height: calc(100vh - 170px);
    border: 2px solid #525659;
  }
}
</style>
